import {connect} from "react-redux";

import Notifications from "../../../components/Dashboard/DashboardUser/Notifications";

import * as StudentActions from "../../../store/actions/studentActions";
import * as RemindersActions from "../../../store/actions/remindersActions";
import * as VideoActions from '../../../store/actions/videoActions';

const mapStateToProps = (state) => ({
    ...state.reminders,
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (profileId, courseId, token) => {
        dispatch(VideoActions.getUserCourseContent(courseId, token));
        dispatch(VideoActions.getCourseUser(profileId, token));
        dispatch(RemindersActions.getReminders());
    },
    getLocation: () =>{
        dispatch(StudentActions.getLocationStudent())
    },
    getCurrentSubject: (subjectId, token) => {
        dispatch(VideoActions.getUserSubject(subjectId, token));
    },
    updateCourseUser: (cu, pid, token) => {
        dispatch(VideoActions.updateCourseUser(cu, pid, token));
    },
    initialNotifications: (courseId, created, profileId, token) => {
        dispatch(VideoActions.getNotifications(courseId, created, profileId, token));
    },
    loadNotifications: (courseId, created, profileId, skip, token) => {
        dispatch(VideoActions.getMoreNotifications(courseId, created, profileId, skip, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Notifications);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardUser/NotificationContainer.js